<template>
  <div class="container mt-3">
    <h5 class="mb-3">个人资料</h5>
    <div class="mb-2">昵称：<b-form-input v-model="user_nick" size="sm" class="w-25 d-inline-block" disabled></b-form-input></div>
    <div class="mb-2">原密码：<b-form-input type="password" v-model="old_password" size="sm" class="w-25 d-inline-block"></b-form-input></div>
    <div class="mb-2">新密码：<b-form-input type="password" v-model="new_password1" size="sm" class="w-25 d-inline-block"></b-form-input></div>
    <div class="mb-2">确认新密码：<b-form-input type="password" v-model="new_password2" size="sm" class="w-25 d-inline-block"></b-form-input></div>
    <div class="mb-2 d-flex align-items-center">
      <!-- <img :src="avatarUrl" alt="avatar" style="width:60px;height:60px;border-radius:50%;object-fit:cover;border:1px solid #eee;" />
      <b-form-file v-model="file" accept="image/*" class="ml-3" browse-text="上传头像" @input="uploadAvatar"></b-form-file> -->
    </div>
    <b-button variant="primary" size="sm" @click="save">修改密码</b-button>
    <b-alert :show="msg!==''" variant="info" class="mt-2">{{ msg }}</b-alert>

    <hr class="my-4">
    <h5 class="mb-3">账号绑定</h5>
    <div class="mb-2 d-flex align-items-center">
      <span class="mr-3">微信：</span>
      <div v-if="wx_name" class="d-flex align-items-center">
        <img :src="wx_avatar" alt="wx" style="width:30px;height:30px;border-radius:50%;margin-right:10px;" v-if="wx_avatar"/>
        <span class="text-success font-weight-bold">{{ wx_name }} (已绑定)</span>
      </div>
      <div v-else>
        <span class="text-muted mr-2">未绑定</span>
        <b-button variant="outline-success" size="sm" @click="showBindModal">立即绑定</b-button>
      </div>
    </div>

    <!-- 微信绑定弹窗 -->
    <b-modal v-model="showWxModal" title="绑定微信" hide-footer centered @shown="onModalShown">
      <div class="text-center">
        <div id="wx-qrcode" style="min-height: 300px;"></div>
        <p class="text-muted mt-2">请使用微信扫一扫进行绑定</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'
export default {
  data(){ 
    return { 
      user_nick:'', 
      old_password:'', 
      new_password1:'', 
      new_password2:'', 
      avatarUrl:'', 
      file:null, 
      msg:'',
      // WeChat binding data
      wx_name: '',
      wx_avatar: '',
      showWxModal: false,
      wechatQrInited: false
    } 
  },
  mounted(){ this.load() },
  methods:{
    load(){ 
      request_zzquant({ url:'/user/profile/me' }).then(res=>{ 
        const d=res.data&&res.data.data?res.data.data:{}; 
        this.user_nick=d.user_nick||''; 
        this.avatarUrl=d.avatar_url||this.full(d.avatar); 
        this.wx_name = d.wx_name || '';
        this.wx_avatar = d.wx_avatar || '';
      }) 
    },
    uploadAvatar(){ if(!this.file) return; const form=new FormData(); form.append('file',this.file); request_zzquant({ url:'/user/profile/avatar/upload', method:'POST', data:form, headers:{ 'Content-Type':'multipart/form-data' } }).then(res=>{ const url=res.data&&res.data.data?res.data.data.url:null; if(url){ this.avatarUrl=url; this.file=null; try{ const raw=localStorage.getItem('user_info'); const info=raw?JSON.parse(raw):{}; info.avatar_url=url; localStorage.setItem('user_info', JSON.stringify(info)); window.dispatchEvent(new CustomEvent('user-login', { detail: { userInfo: info } })); }catch(e){ this.msg = '头像已更新，但本地信息刷新失败'; } } }) },
    save(){ if(!this.old_password||!this.new_password1||!this.new_password2){ this.msg='请输入完整的密码信息'; return } request_zzquant({ url:'/user/profile/password', method:'POST', data:{ old_password:this.old_password, new_password1:this.new_password1, new_password2:this.new_password2 } }).then(()=>{ this.msg='密码已更新'; this.old_password=''; this.new_password1=''; this.new_password2=''; }) },
    full(u){ if(!u) return ''; if(u.startsWith('http')) return u; return 'https://api.zizizaizai.com'+u },
    
    showBindModal() {
      this.showWxModal = true;
    },
    onModalShown() {
      if (!this.wechatQrInited) {
        this.initWeChatQr();
      }
    },
    async initWeChatQr() {
      try {
        await this.loadWxLoginScript()
        const appid = process.env.VUE_APP_WECHAT_QR_APPID || 'wx45ac2ee1309c6e44'
        const origin = process.env.VUE_APP_WECHAT_REDIRECT_ORIGIN || window.location.origin
        const redirectPath = '/login/wx/bind/callback'
        const redirectUri = encodeURIComponent(`${origin}${redirectPath}`)
        
        /* global WxLogin */
        new WxLogin({
          id: 'wx-qrcode',
          appid,
          scope: 'snsapi_login',
          redirect_uri: redirectUri,
          state: 'bind',
          style: 'black',
          href: ''
        })
        this.wechatQrInited = true
      } catch (e) {
        console.error('初始化微信二维码失败', e)
        this.msg = '加载微信二维码失败，请稍后重试'
      }
    },
    loadWxLoginScript() {
      return new Promise((resolve, reject) => {
        if (window.WxLogin) {
          resolve()
        } else {
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
          script.onload = () => resolve()
          script.onerror = () => reject()
          document.head.appendChild(script)
        }
      })
    }
  }
}
</script>

<style>
</style>
